import { initialState } from "./state";

export const setProfilePosts = (state, payload) => {
  state.profilePosts = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
